import { api } from ".";

/**
 * CLE-2628 — one claim inside a combined encounter.
 *
 * When a payer treats separate claim numbers as one encounter (an office visit billed apart from the
 * lab it drew blood for), the claims list shows a single combined row. This is the per-claim
 * breakdown behind it.
 *
 * `expectedAmount` / `amountDifference` / `paymentType` are null on the PRIMARY: its stored values
 * describe the combined case, so repeating them on its own row would read as though that one claim
 * had been priced alone.
 */
export interface ICombinedClaim {
  id: string;
  claimNumber: string | null;
  serviceDate: string | null;
  caseSignature: string | null;
  chargeAmount: number | null;
  claimAmount: number | null;
  totalPaid: number | null;
  expectedAmount: number | null;
  amountDifference: number | null;
  paymentType: string | null;
  isPrimary: boolean;
}

export interface ICombinedClaimsResponse {
  data: ICombinedClaim[];
}

const claimCombinedClaimsQueries = api.injectEndpoints({
  endpoints: (builder) => ({
    getCombinedClaims: builder.query<ICombinedClaimsResponse, string>({
      query: (claimId) => `claims/${claimId}/combined-claims`,
      providesTags: (_r, _e, claimId) => [
        { type: "Claims", id: `combined-claims-${claimId}` },
      ],
    }),
  }),
});

export const { useGetCombinedClaimsQuery } = claimCombinedClaimsQueries;
